// GraphQL query for organization coordinates
export const orgCoordsQuery = `
  query OrgCoords {
    org_coords(first: 10000, where: {}) {
      edges {
        node {
          objectId
          createdAt
          updatedAt
          latitude
          longitude
          org_pointer {
            objectId
            nome
            stato
            tipo_istanza
            indirizzo
            cap
            citta
            nazione
          }
        }
      }
    }
  }
`; 